import { render, staticRenderFns } from "./CreateUpdateMsInd.vue?vue&type=template&id=131eadcc&scoped=true"
import script from "./CreateUpdateMsInd.vue?vue&type=script&lang=js"
export * from "./CreateUpdateMsInd.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateMsInd.vue?vue&type=style&index=0&id=131eadcc&prod&scoped=true&lang=scss"
import style1 from "./CreateUpdateMsInd.vue?vue&type=style&index=1&id=131eadcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131eadcc",
  null
  
)

export default component.exports